var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _path10, _path11, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkhbarAalanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 54,
    viewBox: "0 0 159 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 54,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3387,
    transform: "translate(-572 -1826)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -473,
    y: -177,
    width: 1242,
    height: 587,
    rx: 20,
    fill: "url(#paint0_linear_0_1)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -29,
    width: 344,
    height: 372,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.469 18.4364C153.549 18.4364 151.993 19.9927 151.993 21.9125V41.6531C151.993 43.5729 153.549 45.1292 155.469 45.1292C157.389 45.1292 158.945 43.5729 158.945 41.6531V21.9125C158.945 19.9927 157.389 18.4364 155.469 18.4364Z",
    fill: "#0AA0FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.849 20.5826C91.9291 20.5826 90.3728 22.1389 90.3728 24.0588V38.9009C90.3728 41.5701 88.2011 43.7419 85.5318 43.7419C83.6119 43.7419 82.0557 45.2982 82.0557 47.2181C82.0557 49.1379 83.6119 50.6942 85.5318 50.6942C92.0344 50.6942 97.3219 45.4066 97.3219 38.9041V24.062C97.3219 22.1421 95.7656 20.5858 93.8458 20.5858",
    fill: "#0AA0FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.79 20.8249H133.043C131.123 20.8249 129.567 22.3812 129.567 24.3011C129.567 26.2209 131.123 27.7772 133.043 27.7772H136.79C139.459 27.7772 141.631 29.949 141.631 32.6183C141.631 35.2875 139.459 37.4593 136.79 37.4593H130.122C127.452 37.4593 125.281 35.2875 125.281 32.6183V24.0619C125.281 22.142 123.724 20.5858 121.805 20.5858C119.885 20.5858 118.328 22.142 118.328 24.0619V32.3823C118.328 35.0484 116.157 37.2169 113.491 37.2169C110.824 37.2169 108.65 35.0452 108.65 32.3759V13.1679C108.65 11.2481 107.093 9.69177 105.173 9.69177C103.254 9.69177 101.697 11.2481 101.697 13.1679V32.3759C101.697 38.8785 106.985 44.166 113.487 44.166C116.667 44.166 119.556 42.8999 121.68 40.843C123.823 43.0402 126.811 44.4084 130.115 44.4084H136.784C143.283 44.4084 148.574 39.1208 148.574 32.6183C148.574 26.1157 143.283 20.8281 136.784 20.8281",
    fill: "#0AA0FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.385 16.6408C138.305 16.6408 139.861 15.0846 139.861 13.1647C139.861 11.2449 138.305 9.6886 136.385 9.6886C134.465 9.6886 132.909 11.2449 132.909 13.1647C132.909 15.0846 134.465 16.6408 136.385 16.6408Z",
    fill: "#0AA0FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.711 14.1757H155.469C154.911 14.1757 154.458 13.7228 154.458 13.1647C154.458 12.6066 154.911 12.1538 155.469 12.1538H157.711C158.39 12.1538 158.942 11.602 158.942 10.9228C158.942 10.2435 158.39 9.69177 157.711 9.69177H155.469C153.552 9.69177 151.993 11.2512 151.993 13.1679C151.993 15.0846 153.552 16.644 155.469 16.644H157.711C158.39 16.644 158.942 16.0923 158.942 15.413C158.942 14.7337 158.39 14.182 157.711 14.182",
    fill: "#0AA0FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.494 46.4558C111.574 46.4558 110.018 48.0121 110.018 49.9319C110.018 51.8518 111.574 53.4081 113.494 53.4081C115.414 53.4081 116.97 51.8518 116.97 49.9319C116.97 48.0121 115.414 46.4558 113.494 46.4558Z",
    fill: "#0AA0FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 6,
    width: 44,
    height: 48
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9253 37.5518C35.9253 48.7998 42.0261 53.4048 48.012 53.4048C54.7889 53.4048 62.1079 46.4972 62.1079 32.5927L53.5547 32.9467C53.5547 36.4994 52.4162 43.9332 48.8667 43.9332C45.6425 43.9332 45.0047 39.1304 45.0047 36.7641C45.0047 25.7298 53.1624 14.4627 61.8463 14.4627C70.5303 14.4627 73.5567 24.3967 73.5567 29.7257C73.5567 39.5928 68.1799 48.0759 67.0605 49.5205C66.5343 50.2444 66.7895 50.9652 67.2423 51.367C67.9025 51.957 68.7731 51.7816 69.3631 51.1214C70.5462 49.8043 78.7518 39.6566 78.7518 26.9608C78.7518 15.5151 71.9749 6.17419 61.1224 6.17419C47.2498 6.17419 35.9253 23.4751 35.9253 37.555",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.7518 6.17419H35.9253V53.408H78.7518V6.17419Z",
    fill: "url(#paint1_radial_0_1)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0965 30.8707C10.6387 27.5572 13.4228 25.1526 16.344 25.5449C19.3322 25.8702 21.2999 28.7946 20.7577 32.108C20.2156 35.3546 17.4315 37.7591 14.5103 37.4339C11.5221 37.1086 9.62137 34.1204 10.0965 30.8707Z",
    fill: "#DF1995"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 32,
    height: 38
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.634 16.2997C24.8272 16.6601 24.3935 17.5658 24.757 18.3694C25.229 19.6387 26.3261 23.0478 26.3261 27.9846C26.3261 37.4435 20.2062 43.4613 14.1851 43.4613C8.16411 43.4613 4.73263 38.9391 4.73263 33.1509C4.73263 27.3627 7.99828 22.3367 8.34908 21.7594C8.70626 21.1152 8.54361 20.2542 7.9026 19.897C7.26159 19.476 6.46432 19.6387 6.04335 20.2797C2.89252 24.7572 0 30.319 0 38.5979C0 46.1497 5.60326 53.4081 13.6207 53.4081C23.4718 53.4081 31.2692 43.0882 31.2692 32.5386C31.6646 23.2041 27.8919 17.4478 27.5826 16.9088C27.3211 16.4272 26.8172 16.1721 26.2814 16.1721C26.0646 16.1721 25.8445 16.2136 25.634 16.2997Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2662 0.753035L-18.144 38.984L19.3906 68.8404L49.8009 30.6094L12.2662 0.753035Z",
    fill: "url(#paint2_linear_0_1)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8166 0.252057C59.0781 0.580535 58.8836 1.10674 58.6859 1.56597C58.3574 2.28989 57.4357 3.54002 56.1218 3.54002C54.741 3.54002 52.8307 2.8161 51.976 2.8161C51.4498 2.8161 50.9236 2.94685 50.3974 3.40927C50.1359 3.67397 49.7404 3.67397 49.4757 3.54002C49.1473 3.27533 49.1473 2.55459 49.345 2.02839C49.6735 1.17371 50.5281 0.185087 51.7783 0.185087C52.7637 0.185087 55.264 0.842041 56.0549 0.842041C56.5141 0.842041 57.0403 0.711288 57.5665 0.248868C58.0257 -0.146581 58.5519 -0.0126389 58.8166 0.248868",
    fill: "#F57046"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 55,
    height: 52
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29505 17.1607C7.8996 17.6869 7.96657 18.4109 8.4258 18.8701C9.01897 19.4633 9.80668 19.4633 10.3999 18.9371C14.4118 14.989 20.5667 8.82442 32.0124 8.82442C46.4846 8.82442 53.5548 21.8296 53.5548 32.95C53.5548 36.5027 52.4163 43.9365 48.8668 43.9365L48.0122 53.4081C54.789 53.4081 62.108 46.5005 62.108 32.596C62.108 16.8068 51.4883 2.64075 34.4872 2.64075C23.6984 2.64075 12.7694 10.6486 8.29505 17.1607Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2635 -23.612L-16.6851 34.3353L41.7461 79.6592L86.6947 21.7118L28.2635 -23.612Z",
    fill: "url(#paint3_linear_0_1)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -438.317,
    y1: 410,
    x2: 334.626,
    y2: -558.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.7183 47.935) scale(26.511 46.6375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 3.21111,
    y1: 25.976,
    x2: 24.0013,
    y2: 42.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E5307F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E01F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 49.2266,
    y1: 37.6017,
    x2: 19.381,
    y2: 14.4511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FC9129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6783E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ED5062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA426F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3387,
    fill: "white",
    transform: "translate(-572 -1826)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkhbarAalanLogo);
export default __webpack_public_path__ + "static/media/akhbar-aalan-logo.3181f74095a0b70ccde4386ec808937c.svg";
export { ForwardRef as ReactComponent };